<script setup lang="ts">
import { onMounted } from 'vue';
import { register } from 'swiper/element/bundle';
import AccordionsHelper from '@/helpers/website/accordions.helper';

const buildYourOwnScrollButtonLogic = () => {
  const buildYourOwnScrollButtons = document.querySelectorAll('.cb-build-your-own-scroll-button');

  if (buildYourOwnScrollButtons.length > 0) {
    buildYourOwnScrollButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const buildYourOwnApp = document.querySelector('#farnam-build-your-own-app-wrapper');

        buildYourOwnApp?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
};

const getAQuoteModalOpenButtonLogic = () => {
  const getAQuoteModalOpenButtons = document.querySelectorAll('.cb-get-a-quote-modal-open-button');

  if (getAQuoteModalOpenButtons.length > 0) {
    const hiddenSectionsSelectors = [
      '.contact-form-heading-block.what-are-you-heating',
      '.what-are-you-heating.slide-content',
      '.more-info-section',
      '.products-of-interest',
      '#how-did-you-find-us',
    ];
    getAQuoteModalOpenButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          hiddenSectionsSelectors.forEach((selector) => {
            if (document.querySelector(selector)) {
              document.querySelector(selector).style.cssText = '';
            }
          });
        }, 100);
      });
    });
  }
};

const determineYourHeaterButtonLogic = () => {
  const buildYourOwnScrollButtons = document.querySelectorAll('.cb-sureheat-dyh-scroll-button');

  if (buildYourOwnScrollButtons.length > 0) {
    buildYourOwnScrollButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const sureHeatAppWrapEl = document.querySelector('.sureheat-app-wrapper');

        sureHeatAppWrapEl?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
};

const loadExternalLibraries = () => {
  const contentBuilderArea = document.querySelector('.content-builder-area');

  if (contentBuilderArea !== null) {
    if (contentBuilderArea.querySelector('.farnam-bootstrap')) {
      const styleFarnamBootstrap = document.createElement('link');
      styleFarnamBootstrap.rel = 'stylesheet';
      styleFarnamBootstrap.type = 'text/css';
      styleFarnamBootstrap.href = STATIC_URL + 'farnam-custom/css/farnam-bootstrap.css';
      styleFarnamBootstrap.id = 'farnam-bootstrap';
      document.head.appendChild(styleFarnamBootstrap);
    }

    if (contentBuilderArea.querySelector('.script-jquery')) {
      const scriptJQuery = document.createElement('script');
      scriptJQuery.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js';
      scriptJQuery.type = 'text/javascript';
      scriptJQuery.id = 'script-jquery';

      scriptJQuery.onload = () => {
        if (contentBuilderArea.querySelector('.script-bootstrap')) {
          const scriptBootstrap = document.createElement('script');
          scriptBootstrap.src = 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/js/bootstrap.min.js';
          scriptBootstrap.type = 'text/javascript';
          scriptBootstrap.id = 'script-re-captcha';
          document.body.append(scriptBootstrap);
        }

        if (contentBuilderArea.querySelector('.script-pulsate')) {
          const scriptPulsate = document.createElement('script');
          scriptPulsate.src = 'https://cdn.jsdelivr.net/npm/my-jquery-pulsate@1.0.0/jquery.pulsate.min.js';
          scriptPulsate.type = 'text/javascript';
          scriptPulsate.id = 'script-pulsate';
          document.body.append(scriptPulsate);
        }

        if (contentBuilderArea.querySelector('.script-validator')) {
          const scriptValidator = document.createElement('script');
          scriptValidator.src = STATIC_URL + 'farnam-custom/js/validator.min.js';
          scriptValidator.type = 'text/javascript';
          scriptValidator.id = 'script-re-captcha';
          document.body.append(scriptValidator);
        }
      };
      document.body.append(scriptJQuery);
    }

    if (contentBuilderArea.querySelector('.script-re-captcha')) {
      const scriptReCaptcha = document.createElement('script');
      scriptReCaptcha.src = 'https://www.google.com/recaptcha/api.js';
      scriptReCaptcha.type = 'text/javascript';
      scriptReCaptcha.id = 'script-re-captcha';
      document.body.append(scriptReCaptcha);
    }

    if (contentBuilderArea.querySelector('.sureheat-app-wrapper')) {
      const path = STATIC_URL + 'sureheat-app/';

      const fontAwesomeCss = document.createElement('link');
      fontAwesomeCss.href = STATIC_URL + 'fonts/fontawesome/css/all.min.css';
      fontAwesomeCss.type = 'text/css';
      fontAwesomeCss.rel = 'stylesheet';
      document.head.append(fontAwesomeCss);

      const styleVendors = document.createElement('link');
      styleVendors.href = path + 'css/chunk-vendors_' + SOLAR_SITE_VERSION + '.css';
      styleVendors.type = 'text/css';
      styleVendors.rel = 'stylesheet';
      document.head.append(styleVendors);

      const styleApp = document.createElement('link');
      styleApp.href = path + 'css/app_' + SOLAR_SITE_VERSION + '.css';
      styleApp.type = 'text/css';
      styleApp.rel = 'stylesheet';
      document.head.append(styleApp);

      const scriptVendors = document.createElement('script');
      scriptVendors.src = path + 'js/chunk-vendors_' + SOLAR_SITE_VERSION + '.js';
      scriptVendors.type = 'text/javascript';
      document.body.append(scriptVendors);

      const scriptApp = document.createElement('script');
      scriptApp.src = path + 'js/app_' + SOLAR_SITE_VERSION + '.js';
      scriptApp.type = 'text/javascript';
      document.body.append(scriptApp);
    }
  }
};

const videoLibraryLogic = () => {
  const videoLibraryItemsList = document.querySelectorAll('.cb-video-library-item');

  if (videoLibraryItemsList.length > 0) {
    videoLibraryItemsList.forEach((videoItem) => {
      videoItem.addEventListener('click', () => {
        const dynamicModal = document.querySelector('#dynamic-modal');

        if (dynamicModal !== null) {
          dynamicModal.querySelector('.dynamic-modal-content-wrap').style.width = '760px';
          dynamicModal.classList.add('opacity-100', 'pointer-events-auto');
          dynamicModal.querySelector('.dynamic-modal-content').innerHTML = `<div class="cb-video-library-modal-content">
            <div class="title">${videoItem.getAttribute('data-video-title')}</div>
            <div class="video">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/${videoItem.getAttribute('data-video-id')}"
                title="${videoItem.getAttribute('data-video-title')}"
                data-description="${videoItem.getAttribute('data-video-description')}"
                data-poster="${videoItem.getAttribute('data-video-poster')}"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen>
              </iframe>
            </div>
            <p class="description">${videoItem.getAttribute('data-video-description')}</p>
          </div>`;
        }
      });
    });
  }
};

// Products slider
const initCbProductsSlider = async () => {
  await customElements.whenDefined('swiper-container');

  document.querySelectorAll<HTMLElement>('swiper-container.cb-products-slider').forEach((el: any) => {
    const wrap = document.createElement('div');
    wrap.className = 'cb-products-slider-wrap';
    wrap.style.position = 'relative';
    el.parentElement?.insertBefore(wrap, el);
    wrap.appendChild(el);

    const makeBtn = (cls: string, svg: string) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `cb-nav ${cls}`;
      b.innerHTML = svg;
      return b;
    };

    const prevBtn = makeBtn(
      'cb-prev',
      `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M9.99506 19.2426C4.75069 19.3802 0.386862 15.2395 0.249266 9.99516C0.11167 4.75078 4.25236 0.386764 9.49673 0.249168C14.7411 0.111572 19.1049 4.25246 19.2425 9.49683C19.3801 14.7412 15.2394 19.105 9.99506 19.2426ZM9.9622 17.99C14.5151 17.8705 18.1093 14.0826 17.9899 9.5297C17.8704 4.97681 14.0825 1.38259 9.52961 1.50204C4.97671 1.6215 1.38249 5.4094 1.50195 9.96229C1.6214 14.5152 5.4093 18.1094 9.9622 17.99Z" fill="#76766F"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.22786 9.44224L11.775 5.11117C12.1017 4.89435 12.5374 5.12197 12.5476 5.51378L12.7657 13.8253C12.776 14.2171 12.3531 14.4673 12.0152 14.2679L5.25 10.2861C4.93324 10.1003 4.92128 9.64458 5.22786 9.44224Z" fill="#76766F"/>
      </svg>`
    );
    const nextBtn = makeBtn(
      'cb-next',
      `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
        <path d="M9.4999 0C14.7461 0 18.9998 4.25372 18.9998 9.4999C18.9998 14.7461 14.7461 19 9.4999 19C4.25372 19 0 14.7461 0 9.4999C0 4.25372 4.25372 0 9.4999 0ZM9.4999 1.25311C4.94544 1.25311 1.25311 4.94544 1.25311 9.4999C1.25311 14.0544 4.94544 17.7467 9.4999 17.7467C14.0544 17.7467 17.7467 14.0544 17.7467 9.4999C17.7467 4.94544 14.0544 1.25311 9.4999 1.25311Z" fill="#76766F"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0084 9.92203L7.34995 14.0799C7.01765 14.2881 6.58813 14.0491 6.58813 13.6572V5.34278C6.58813 4.95084 7.01746 4.71187 7.34995 4.92005L14.0084 9.07791C14.3202 9.27195 14.3202 9.7278 14.0084 9.92203Z" fill="#76766F"/>
      </svg>`
    );

    wrap.append(prevBtn, nextBtn);

    Object.assign(el, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      autoplay: { delay: 3000, disableOnInteraction: false },
      navigation: { prevEl: prevBtn, nextEl: nextBtn },
      autoHeight: true,
      breakpoints: {
        360: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1280: { slidesPerView: 4 },
      },
    });

    el.initialize();

    el.addEventListener('mouseenter', () => el.swiper?.autoplay?.stop());
    el.addEventListener('mouseleave', () => el.swiper?.autoplay?.start());
  });
};

// Partners slider
const initPartnersSlider = async () => {
  await customElements.whenDefined('swiper-container');

  document.querySelectorAll<HTMLElement>('swiper-container.cb-partners-slider').forEach((el: any) => {
    Object.assign(el, {
      slidesPerView: 2,
      spaceBetween: 22,
      loop: true,
      autoplay: { delay: 2000, disableOnInteraction: false },
      breakpoints: {
        480: { slidesPerView: 3 },
        768: { slidesPerView: 4 },
        1280: { slidesPerView: 5 },
        1440: { slidesPerView: 6 },
      },
    });

    el.initialize();
  });
};

onMounted(() => {
  // Swiper Initialization
  register();

  AccordionsHelper.initAccordionsLogic();
  buildYourOwnScrollButtonLogic();
  getAQuoteModalOpenButtonLogic();
  determineYourHeaterButtonLogic();
  loadExternalLibraries();
  videoLibraryLogic();
  initCbProductsSlider();
  initPartnersSlider();
});
</script>

<style lang="scss">
@use '@/styles/global/content-builder/content-builder-blocks-default-styles-clean.css' as *;
@use '@/styles/global/content-builder/content-builder-global-custom-styles.scss' as *;
@use '@/styles/global/content-builder/content-builder-custom-snippets-styles.scss' as *;
@use '@/styles/website/content-builder/content-builder-website-custom-styles.scss' as *;
</style>
